// extracted by css-extract-rspack-plugin
export default {"container":"ad-cell-module__container___LlSFL","containerTitle":"ad-cell-module__containerTitle___mMY1V","ad":"ad-cell-module__ad___10gAR"};